import React from "react"
import { Box, Divider, Heading } from "@theme-ui/components"

const SectionTitle = ({ title, alignement, dark }) => (
  <Box mb={4} sx={{ textAlign: alignement || "center" }}>
    <Heading
      as="h3"
      variant="displaySmall"
      pb={3}
      sx={{ color: dark ? "light" : "inherit" }}
    >
      {title}
    </Heading>
    <Divider
      sx={{
        width: "52px",
        height: "10px",
        margin: alignement === "left" ? null : "auto",
        color: "primary",
        backgroundColor: "primary",
      }}
    />
  </Box>
)

export default SectionTitle
